<template>
  <div class="tw-bg-gray-100 tw-rounded-lg inbox-notification-group">
    <div
      class="
        tw-flex
        tw-flex-row
        tw-justify-between
        tw-align-center
        tw-py-4
        tw-px-6
        tw-sticky
        tw-bg-gray-100
        tw-rounded-lg
        tw-z-40
        inbox-notification-group--header
      "
      :data-testid="`inbox-notification-group-${name}`"
    >
      <span class="tw-flex tw-flex-row tw-align-baseline">
        <i
          data-testid="inbox-notification-group-toggle"
          class="tw-text-xs icon tw-w-6 tw-p-1 tw-text-center tw-cursor-pointer"
          :class="expanded ? 'icon-chevron-down' : 'icon-chevron-right'"
          @click="toggleExpanded"
        />
        <span class="tw-text-base tw-font-medium">{{ name }}</span>
      </span>
      <span>
        <span
          class="
            tw-uppercase tw-font-medium tw-text-xs tw-text-sf-gray-dark tw-p-2
          "
        >
          {{ messagesCopy }}
        </span>
        <SfButtonInverted
          v-if="showMarkAsRead"
          small
          inline
          variant="dark"
          :disabled="disableMarkAsRead"
          @click="emit('markAsRead')"
        >
          <span
            data-testid="inbox-notification-group-mark-as-read"
            class="tw-flex tw-flex-row tw-align-baseline tw-gap-2"
          >
            <i class="icon icon-envelope-open" />
            {{ I18n.t('communication.inbox.mark_as_read') }}
          </span>
        </SfButtonInverted>
      </span>
    </div>
    <div v-if="expanded" class="tw-flex tw-flex-col tw-px-6 tw-pb-6 tw-gap-4">
      <slot name="default" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import SfButtonInverted from '@app/shared/vue/components/sf-button/sf-button-inverted.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'

const emit = defineEmits<{ markAsRead: [] }>()

interface Props {
  disableMarkAsRead: boolean
  showMarkAsRead: boolean
  name: string
  numberOfMessages: number
}

const props = defineProps<Props>()

const expanded = ref<boolean>(true)
function toggleExpanded() {
  expanded.value = !expanded.value
}

const I18n = useI18n()

const messagesCopy = computed(() =>
  I18n.t('communication.inbox.messages', { count: props.numberOfMessages })
)
</script>

<style scoped>
.inbox-notification-group--header {
  top: var(--sf-inbox-notification-group-sticky-offset);
}
</style>
